import {
  createContext,
  useMemo,
  useState,
} from 'react';

interface SelectedElementContextProps {
  selectedElementId: string | null;
  setSelectedElementId: (id: string | null) => void;
}

export const SelectedElementContext = createContext<SelectedElementContextProps>(
  {} as SelectedElementContextProps,
);
SelectedElementContext.displayName = 'SelectedElementContext';

interface Props {
  children: React.ReactNode;
}

export const SelectedElementProvider: React.FC<Props> = ({ children }: Props) => {
  const [selectedElementId, setSelectedElementId] = useState<string | null>(null);

  const contextValue = useMemo(() => ({
    selectedElementId,
    setSelectedElementId,
  }), [selectedElementId, setSelectedElementId]);

  return (
    <SelectedElementContext.Provider value={contextValue}>
      {children}
    </SelectedElementContext.Provider>
  );
};
